import { render, staticRenderFns } from "./select-sigle-assignment.component.vue?vue&type=template&id=20a4310e&"
import script from "./select-sigle-assignment.component.vue?vue&type=script&lang=ts&"
export * from "./select-sigle-assignment.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports